import type { Variants } from 'motion/react';
import { MOTION_DURATIONS, MOTION_EASINGS, MOTION_OFFSETS } from './tokens';

export const fadeInVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: MOTION_DURATIONS.fast,
      ease: MOTION_EASINGS.vyora,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: MOTION_DURATIONS.instant,
      ease: MOTION_EASINGS.easeIn,
    },
  },
};

export const slideUpVariants: Variants = {
  hidden: {
    opacity: 0,
    y: MOTION_OFFSETS.sm,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: MOTION_DURATIONS.normal,
      ease: MOTION_EASINGS.vyora,
    },
  },
  exit: {
    opacity: 0,
    y: -MOTION_OFFSETS.subtle,
    transition: {
      duration: MOTION_DURATIONS.instant,
      ease: MOTION_EASINGS.easeIn,
    },
  },
};

export const modalVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.97,
    y: MOTION_OFFSETS.sm,
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: MOTION_DURATIONS.normal,
      ease: MOTION_EASINGS.vyora,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.98,
    y: MOTION_OFFSETS.subtle,
    transition: {
      duration: MOTION_DURATIONS.fast,
      ease: MOTION_EASINGS.easeIn,
    },
  },
};

export const drawerVariants: Variants = {
  hidden: {
    x: '100%',
  },
  visible: {
    x: 0,
    transition: {
      duration: MOTION_DURATIONS.moderate,
      ease: MOTION_EASINGS.vyora,
    },
  },
  exit: {
    x: '100%',
    transition: {
      duration: MOTION_DURATIONS.fast,
      ease: MOTION_EASINGS.easeIn,
    },
  },
};

export const toastVariants: Variants = {
  hidden: {
    opacity: 0,
    y: -MOTION_OFFSETS.md,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: MOTION_DURATIONS.normal,
      ease: MOTION_EASINGS.vyora,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: MOTION_DURATIONS.fast,
      ease: MOTION_EASINGS.easeIn,
    },
  },
};

export const staggerContainerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: (custom: { stagger?: number; delay?: number } = {}) => ({
    opacity: 1,
    transition: {
      staggerChildren: custom.stagger ?? 0.04,
      delayChildren: custom.delay ?? 0.02,
    },
  }),
};

export const staggerItemVariants: Variants = {
  hidden: {
    opacity: 0,
    y: MOTION_OFFSETS.sm,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: MOTION_DURATIONS.normal,
      ease: MOTION_EASINGS.vyora,
    },
  },
};
